import { RefObject, useEffect } from 'react';

// uses to return focus back to related radio option on calendar close
export const useCalendarsKeyboardClose = (
  containerRef: RefObject<HTMLDivElement>,
) => {
  const getCloseCalendarHandler = (calendarContainerClassname: string) => {
    return () => {
      if (!containerRef.current) return;

      const radioOption: HTMLElement | null =
        containerRef.current.querySelector(
          `.${calendarContainerClassname} input`,
        );

      radioOption?.focus();
    };
  };

  useEffect(() => {
    if (!containerRef.current) return;

    const closeStartDateCalendarElement: HTMLElement | null =
      containerRef.current.querySelector(
        '.start-date-input-wrapper .close-date-panel-btn',
      );

    const handleCloseStartDateCalendar = getCloseCalendarHandler(
      'assign-panel-start-date-radio',
    );

    // listening to keydown event breaks calendar appearing logic, defined in amplify-components
    closeStartDateCalendarElement?.addEventListener(
      'click',
      handleCloseStartDateCalendar,
    );

    const closeDueDateCalendarElement = containerRef.current.querySelector(
      '.due-date-input-wrapper .close-date-panel-btn',
    );

    const handleCloseDueDateCalendar = getCloseCalendarHandler(
      'assign-panel-due-date-radio',
    );

    closeDueDateCalendarElement?.addEventListener(
      'click',
      handleCloseDueDateCalendar,
    );

    return () => {
      closeStartDateCalendarElement?.removeEventListener(
        'click',
        handleCloseStartDateCalendar,
      );
      closeDueDateCalendarElement?.removeEventListener(
        'click',
        handleCloseDueDateCalendar,
      );
    };
    //   eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef.current]);
};
